<script>
import CanvasTileLayer from "./CanvasTileLayer";
export default {
  props: {
    leaflet: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
    subdomains: {
      type: String,
    },
  },
  data() {
    return {
      isVisible: this.layer.visible,
    };
  },
  mounted() {
    const options = {
      transparent: true,
      updateWhenZooming: false,
      tileSize: 512,
      description: {
        name: this.layer.name,
        displayName: this.layer.displayName,
      },
      subdomains: this.subdomains ? this.subdomains : "abcd",
      maxZoom: this.map.options.maxZoom,
      opacity: this.layer.opacity || 1.0,
    };

    this._options = options;
    this._currentLayer = new CanvasTileLayer(this.layer.url, options);

    this._currentLayer.addTo(this.map);
    this.$once("hook:beforeDestroy", () => {
      this.map.removeLayer(this._currentLayer);
      this._currentLayer = null;
    });
  },
  watch: {
    "layer.visible": function watchLayerVisible(newValue) {
      if (!this.isVisible && newValue) {
        this.isVisible = true;
        this.map.removeLayer(this._currentLayer);
        this._currentLayer = new CanvasTileLayer(this.layer.url, this._options);
        this._currentLayer.addTo(this.map);
      }
    },
    "layer.opacity": function watchLayerOpacity(newValue) {
      this._currentLayer.setOpacity(newValue);
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>
